export default "__VITE_ASSET__D9EoQ89s__"